import { GiphyFetch } from '@giphy/js-fetch-api';
import envVariables from '../env';
const LIMIT = 15;
// Rate-limited development beta key
const DEFAULT_DEV_GIPHY_API_KEY = 'Z1Xqu6WZibR7EvtWUt17OrrNqXdwDV1F';
const giphyApiKey = envVariables.giphyApiKey !== '__AMITYEKOCI_GIPHY_API_KEY__'
    ? envVariables.giphyApiKey
    : DEFAULT_DEV_GIPHY_API_KEY;
const gf = new GiphyFetch(giphyApiKey);
/**
 * Gets gif data by its ID.
 *
 * @param id - Gif ID.
 * @returns A Promise with a gif data object.
 */
export const getGifById = async (id) => {
    const { data } = await gf.gif(id);
    return data;
};
/**
 * Fetch gifs by search term.
 *
 * @remarks
 * The trending gifs are fetched by default if a search term is not provided.
 *
 * @param offset - Specifies the starting position of the results. It is required for pagination.
 * @param term - Search term.
 * @returns A Promise with gifs data.
 */
export const searchGifs = (offset, term) => {
    if (typeof term === 'string' && term.length > 0) {
        return gf.search(term, { offset, limit: LIMIT });
    }
    return gf.trending({ offset, limit: LIMIT });
};
//# sourceMappingURL=giphy.js.map